export default __webpack_public_path__ + "static/media/expand_less.e25645f8.svg";